import { Injectable, OnDestroy } from '@angular/core'
import {
  AuthActions,
  StateWithClientAuth,
  UserIdService
} from '@spartacus/core'
import { BehaviorSubject, Observable, Subscription } from 'rxjs'
import { MbLogoutConnector } from '../../connectors/mb-logout-connector'
import { OAuthService } from 'angular-oauth2-oidc'
import { map, tap } from 'rxjs/operators'
import { Store } from '@ngrx/store'
import { Router } from '@angular/router'

@Injectable({
  providedIn: 'root',
})
export class MbLogoutService implements OnDestroy {
  logout$ = new BehaviorSubject<boolean>(true)
  private subscription: Subscription = new Subscription()

  constructor (
    protected userIdService: UserIdService,
    protected logoutConnector: MbLogoutConnector,
    protected oAuthService: OAuthService,
    protected store: Store<StateWithClientAuth>,
    protected router: Router
  ) {}

  logout (doRedirect: boolean = true) {
    return  this.logoutConnector.occLogout().pipe(
      map(() => this.feLogout()),
      tap({ complete: () => { if (doRedirect) { this.router.navigateByUrl('/') } } })
    )
  }

  private feLogout () {
    this.userIdService.clearUserId()
    this.oAuthService.logOut(true)
    this.store.dispatch(new AuthActions.Logout())
  }

  ngOnDestroy (): void {
    this.subscription.unsubscribe()
  }
}
